"use client";
import { jsx as h } from "react/jsx-runtime";
import { memo as v } from "react";
import m from "../components/Icon/SvgIcon.js";
const c = (o) => /* @__PURE__ */ h(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ h(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m17.415 20.6-.138-.067v-2.6h1.315V21.2c0 .442-.371.8-.83.8H4.33c-.46 0-.831-.358-.831-.8V2.8c0-.442.372-.8.83-.8h9.97a.28.28 0 0 1 .208.133l4.015 4.4c.098.084.15.208.139.334v3.666h-1.316v-3h-3.323a.34.34 0 0 1-.346-.333V3.467H4.954V20.6zm-9.623-9.4H19.7c.535 0 .97.418.97.933v4.214c0 .515-.435.933-.97.933H7.792c-.535 0-.969-.418-.969-.933v-4.214c0-.515.434-.933.97-.933m3.317 3.257q.205-.136.337-.376.133-.238.132-.592 0-.455-.23-.743a1.04 1.04 0 0 0-.57-.374q-.223-.058-.952-.057H8.54v3.818h.8v-1.44h.523q.543 0 .83-.055.212-.044.415-.18m3.901 1.291q.276-.258.425-.675.12-.34.121-.812 0-.537-.13-.903a1.7 1.7 0 0 0-.378-.619 1.33 1.33 0 0 0-.598-.351q-.26-.073-.754-.073h-1.463v3.818h1.506q.443 0 .71-.08.353-.11.561-.305m2.03-2.787h1.919v-.646H16.24v3.818h.8v-1.622h1.655v-.646H17.04zm-2.62.217a.8.8 0 0 0-.37-.18q-.167-.037-.657-.037h-.36v2.529h.598q.335 0 .483-.037a.75.75 0 0 0 .324-.158q.128-.112.21-.369.08-.256.08-.7 0-.441-.08-.68a.85.85 0 0 0-.227-.368m-4.691-.217q.432 0 .576.026.195.035.32.17.128.135.128.344a.5.5 0 0 1-.34.484q-.16.06-.633.06h-.438V12.96z",
        clipRule: "evenodd"
      }
    )
  }
), a = v(c);
export {
  a as Pdf,
  a as default
};
